import { useDispatch, useSelector } from "react-redux";
import { updateSearchParameters } from "../common/hash/actions";
import { getCurrentHashData } from "../common/hash/selectors";

export default function useItemsPerPage() {
	const dispatch = useDispatch();
	const hashData = useSelector(getCurrentHashData);
	const pageSize = hashData.getIn(["parameters", "page_size"]) || "15";

	const onPageSizeSelected = (pageSize) => {
		dispatch(updateSearchParameters({ page_size: pageSize }));
	};

	return { onPageSizeSelected, pageSize };
}
